<template>
	<section
		:class="[
			'marketing-section bg-color-bg-tertiary',
			{
				'bg-img-dotted-waves-dark': !appStore.isMobile
			}
		]"
	>
		<div class="container">
			<div class="text-align-center">
				<h2 class="overline">Why Fundrise Connect API</h2>
				<h1 class="mt-100 heading-1">One-time integration, <br />tech-forward solutions</h1>
			</div>

			<div
				class="mt-500-md mt-200-smo gap-300-lg gap-150-md display-flex-md align-items-center-md justify-content-center-md"
			>
				<div class="col-5-md mb-150-smo">
					<p class="body-lg"
						>The Fundrise Connect API is a first-of-its-kind set of APIs that allows any platform to
						natively offer Fundrise products to their investors, delivering access to billions of dollars
						worth of institutional-quality private market investments without the typical high costs or
						accreditation requirements.</p
					>
					<p class="body-lg"
						>As Fundrise continues to develop additional investment vehicles, our API will expose them
						automatically, giving any platform the option to be at the bleeding edge of alternative
						assets.</p
					>
					<BaseCtaLink
						classes="body-lg mt-100"
						icon="arrow"
						:link="fundriseConnectDocsLink"
						text="See the docs"
					/>
				</div>
				<div role="figure" class="col-6-md">
					<img v-reveal:fade-up :src="imgUrl" alt="" role="presentation" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { fundriseConnectDocsLink } from '@constants/links';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const imgUrl = computed((): string => {
	return appStore.isMobile
		? `${appCloudfrontPath}/images/marketing-site/connect-api-code-snippet-mobile.png`
		: `${appCloudfrontPath}/images/marketing-site/connect-api-code-snippet.png`;
});
</script>
